import Vue from "vue";
import moment from "moment-jalaali";

Vue.filter('timeAgo', value => moment(value).locale('fa').fromNow());

Vue.filter('onlyTime', value => moment(value).format('HH:mm:ss'));
Vue.filter('onlyDate', value => moment(value).format('jYYYY-jM-jD'));
Vue.filter('longDate', value => moment(value).format('HH:mm jYYYY-jM-jD'));
Vue.filter('rial', value => {
    return (value ?? "").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
})
Vue.filter('userType', value => {
    if (value === 'regular')
        return 'حقوقی';
    return 'حقیقی';
})

Vue.filter('serviceTypeNumber', val => {
    if (val == 2)
        return 'پیامک لند';
    else if (val == 1)
        return 'کورلند';
    else if (val == 3)
        return 'کیوآر لند';
    else if (val == 4)
        return 'ربات لند';
    else if (val == 5)
        return 'بیلبورد';
    else if (val === 'tablighNegar')
        return 'تبلیغ نگار';
    else if (val === 'Transport')
        return 'حمل و نقل';
    else if (val === 'Meli')
        return 'ملی';
    else if (val === 'Media')
        return 'رسانه های تصویری';
    else if (val === 'Info')
        return 'بانک اطلاعاتی';
    else if (val === 'RealEstate')
        return 'املاک';
    else if (val === 'Digi')
        return 'سایت';
    else
        return 'نامعلوم'
})


Vue.filter('transactionType', val => {
    if (val === 'withdraw')
        return 'خرید';
    else if (val === 'deposit')
        return 'برداشت';
    else if (val === 'refund')
        return 'بازگشت وجه';
    else if (val === 'charge')
        return 'شارژ کیف پول';
    else if (val === 'adminCharge')
        return 'شارژ کیف پول توسط ادمین';
    else if (val === 'agency')
        return 'عاملیت';
    else
        return 'نامعلوم'
})

Vue.filter('isEmpty', value => {
    return value ? value : ""
})

Vue.filter('persianNumber', value => {
    return value.toPersianLetter();
})

Vue.filter('numericPersianNumber', value => {
    if (value < 1_000_000)
        return value / 1_000 + " هزار"
    return value / 1_000_000 + " میلیون"
})

// Vue.filter('rial', value => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
